import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import FarolImage from "../../assets/icons/farol.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

function SendDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Com Farol");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);
  const [mesAnterior, setMesAnterior] = useState("");
  const [mesAtual, setMesAtual] = useState("");

  const handleChange = (event) => {
    app.field("Tipo_Envio").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_Envio")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const getMesAnterior = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setMesAnterior(value);
        });
      }
    },
    [app]
  );

  const getMesAtual = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setMesAtual(value);
        });
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getMesAnterior("GqZrZ");
      getMesAtual("LfHsw");
    }
  }, [app, getMesAnterior, getMesAtual, selections]);

  return (
    <div className="app Send">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Com Farol"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Com Farol"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Com Farol"
            />

            <FormControlLabel
              value="Com Texto"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Com Texto"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              {selectedValue === "Com Farol" ? (
                <>
                  <img src={FarolImage} alt="Farol" width={600} />

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês ${mesAnterior}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="JspzV"
                  >
                    <NativeObject
                      app={app}
                      key="JspzV"
                      reference={{ id: "JspzV" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês ${mesAtual}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="PehKH"
                  >
                    <NativeObject
                      app={app}
                      key="PehKH"
                      reference={{ id: "PehKH" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>
                </>
              ) : null}

              {selectedValue === "Com Texto" ? (
                <>
                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês ${mesAnterior}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="JspzV"
                  >
                    <NativeObject
                      app={app}
                      key="JspzV"
                      reference={{ id: "JspzV" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: `Envio de Informações do mês ${mesAtual}`,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="PehKH"
                  >
                    <NativeObject
                      app={app}
                      key="PehKH"
                      reference={{ id: "PehKH" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>
                </>
              ) : null}
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

SendDesktop.defaultProps = {
  app: null,
  config: {},
};

SendDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SendDesktop;
